import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-geolocation-map-viewer',
  templateUrl: './geolocation-map-viewer.component.html',
  styleUrls: ['./geolocation-map-viewer.component.scss'],
})
export class GeolocationMapViewerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() longitude: number | null = null;
  @Input() latitude: number | null = null;
  public readonly mapOptions: google.maps.MapOptions = {
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_CENTER
    },
    streetViewControl: true,
    fullscreenControl: true
  };

  @ViewChild('streetviewSmall') streetviewSmall: any;
  pegmanOption: Element | null = null;
  isStreetViewLayerVisible: boolean = false;
  isStreetViewVisible: boolean = false;
  streetViewLayer!: google.maps.StreetViewCoverageLayer;
  panorama!: google.maps.StreetViewPanorama;
  public agmMap: google.maps.Map | null = null;

  @Input() set setMapVisibility(isMapVisible: boolean) {
    if (!isMapVisible || this.latitude == null || this.longitude == null) {
      return;
    }

    this.initializeViewer();
  }

  ngAfterViewInit(): void {
    if (this.latitude != null && this.longitude != null) {
      this.initializeViewer();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['latitude'] || changes['longitude']) && this.latitude != null && this.longitude != null) {
      this.initializeViewer();
    }
  }

  ngOnDestroy(): void {
    this.removeEventListeners();
  }

  showSmallStreetView(lat: number, lng: number) {
    this.isStreetViewVisible = true;
    if (!this.streetviewSmall) {
      return;
    }

    const streetViewPosition: google.maps.LatLngLiteral = { lat, lng };

    try {
      this.panorama = new google.maps.StreetViewPanorama(this.streetviewSmall.nativeElement, {
        position: streetViewPosition,
        scrollwheel: true,
        zoom: 1,
        fullscreenControl: true,
        showRoadLabels: true,
        visible: true,
        addressControl: false,
        panControl: true,
      });

      this.agmMap?.setStreetView(this.panorama);
    } catch (error) {
      console.error('Error initializing Street View Panorama:', error);
    }
  }

  streetViewToggleListener: EventListener = (_event: Event) => {
    this.isStreetViewLayerVisible = !this.isStreetViewLayerVisible;

    if (this.isStreetViewLayerVisible) {
      this.streetViewLayer.setMap(this.agmMap);
    } else {
      this.streetViewLayer.setMap(null);
    }
  };

  removeEventListeners() {
    if (this.pegmanOption) {
      this.pegmanOption.removeEventListener('click', this.streetViewToggleListener);
    }
  }

  setPegmanClickListener() {
    try {
      setTimeout(() => {
        this.pegmanOption = window.document.querySelector('button.gm-svpc');

        if (this.pegmanOption) {
          this.pegmanOption.addEventListener('click', this.streetViewToggleListener);
        }
      }, 1200);
    } catch (error) {
      console.error('Error setting Pegman click listener:', error);
    }
  }

  private initializeViewer() {
    if (this.latitude == null || this.longitude == null) {
      return;
    }

    this.removeEventListeners();
    this.setPegmanClickListener();
    this.showSmallStreetView(this.latitude, this.longitude);
  }
}
